const Component = () => import('./OrderFeedback');

export { Component };
